// extracted by mini-css-extract-plugin
module.exports = {"right":"Header_right__38M8y","select":"Header_select__1ZMMO","clinic":"Header_clinic__2amX5"};